var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVoteClicked = function SvgVoteClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004BFF",
    d: "M11.525 7.608c-.885.862-1.69 1.636-2.482 2.425-.324.323-.343.681-.002 1.013.328.32.678.338 1.024.016q.159-.152.313-.31c1.95-1.945 3.884-3.907 5.866-5.82.39-.376.939-.654 1.465-.814 1.037-.315 1.969.024 2.746.741.58.535 1.133 1.1 1.678 1.672 1.159 1.216 1.163 2.95-.03 4.146a910 910 0 0 1-7.48 7.403c-1.255 1.229-3.003 1.225-4.252 0q-3.76-3.684-7.48-7.403c-1.185-1.184-1.182-2.94-.027-4.147a42 42 0 0 1 1.68-1.67c1.23-1.149 2.972-1.136 4.179.022.913.877 1.814 1.764 2.801 2.727z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 3,
    x: 2,
    y: 18,
    fill: "#004BFF",
    rx: 1
  })));
};
export default SvgVoteClicked;